import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ReceptionLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  const navBtn = (to, icon, label) => {
    const active = pathname === to;
    return (
      <Link
        to={to}
        className="d-flex align-items-center gap-2 text-decoration-none px-3 py-1 rounded-3"
        style={{
          background: active ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)',
          border: `1px solid ${active ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)'}`,
          color: '#fff',
          fontSize: '0.82rem',
          fontWeight: active ? 700 : 500,
          transition: 'all 0.15s',
        }}
      >
        <i className={`bi ${icon}`} style={{ fontSize: '0.9rem' }}></i>
        <span className="d-none d-sm-inline">{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ background: '#f4f6fb' }}>

      {/* Minimal reception header */}
      <header
        style={{
          background: 'linear-gradient(90deg, #065a30 0%, #086F3C 50%, #065a30 100%)',
          minHeight: 58,
          boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
        }}
      >
        <div
          className="container-fluid px-3 px-lg-5 d-flex align-items-center justify-content-between gap-3"
          style={{ minHeight: 58 }}
        >
          {/* Left: Logo + title */}
          <div className="d-flex align-items-center gap-3 flex-shrink-0">
            <div style={{
              background: '#fff', borderRadius: 10, padding: '4px 8px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 1px 5px rgba(0,0,0,0.15)',
            }}>
              <img src="/think-gas-logo.png" alt="Think Gas" style={{ height: 32, objectFit: 'contain' }} />
            </div>
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: '1rem', fontWeight: 800, color: '#fff', letterSpacing: '0.06em' }}>THINK GAS</div>
              <div style={{ fontSize: '0.48rem', color: 'rgba(255,255,255,0.82)', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                Visitor Registration
              </div>
            </div>
          </div>

          {/* Center: Office badge */}
          {user?.office && (
            <div
              className="d-none d-sm-flex align-items-center gap-2 px-3 py-2 rounded-3"
              style={{ background: 'rgba(255,255,255,0.14)', border: '1px solid rgba(255,255,255,0.28)' }}
            >
              <i className="bi bi-geo-alt-fill" style={{ color: '#ffd700', fontSize: '0.85rem' }}></i>
              <div style={{ lineHeight: 1.15 }}>
                <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#fff' }}>{user.office.name}</div>
                <div style={{ fontSize: '0.58rem', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.04em' }}>
                  {user.office.city}&nbsp;·&nbsp;{user.office.code}
                </div>
              </div>
            </div>
          )}

          {/* Right: subtle logout icon only */}
          <button
            onClick={handleLogout}
            title="Logout"
            style={{
              marginLeft: 'auto',
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'rgba(255,255,255,0.7)',
              borderRadius: 8,
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
          >
            <i className="bi bi-box-arrow-right" style={{ fontSize: '1rem' }}></i>
          </button>
        </div>
      </header>

      <main className="flex-grow-1">
        {children}
      </main>

      <footer className="py-2 text-center text-muted border-top bg-white" style={{ fontSize: '0.72rem' }}>
        <span style={{ color: '#F2652C', fontWeight: 600 }}>THINK GAS</span>
        <span className="mx-2">·</span>
        Visitor Entry Portal
        <span className="mx-2">·</span>
        &copy; {new Date().getFullYear()} All rights reserved
      </footer>
    </div>
  );
};

export default ReceptionLayout;
